import * as Website from '../../Config/Website.js';
import IntroVoiceSlider from './Modules/IntroVoiceSlider.js';
import IntroFvLine from './Modules/IntroFvLine.js';


const preinit = () => {

}

const init = () => {
  IntroVoiceSlider();
  IntroFvLine();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}